import React, { useRef, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { getImageSolInd } from "../utils/getImages";

// Importar iconos Rojo
import iconoAlimentos from '../assets/inicio/iconos/botella-de-agua-Blanco 1.png';
import iconoFarmaceutica from '../assets/inicio/iconos/frasco-con-cruz-Blanco 1.png';
import iconoCosmetica from '../assets/inicio/iconos/frasco-cosm-tico-Blanco 1.png';
import iconoVinos from '../assets/inicio/iconos/botella-de-vino-con-Blanco 1.png';
import iconoAnimal from '../assets/inicio/iconos/silueta-de-mascota---frasco-Blanco 1.png';
import iconoManufacturera from '../assets/inicio/iconos/engrane-Blanco 2.png';
import iconoEventosMasivos from '../assets/inicio/iconos/Estadio-Rojo.png';

import imgAlimentos from '../assets/soluciones-industria/alimentosimg.png';

//Importar iconos Negros
import iconoAlimentosActive from '../assets/inicio/iconos/black/botella-de-agua-Blanco1.png';
import iconoFarmaceuticaActive from '../assets/inicio/iconos/black/frasco-con-cruz-Blanco1.png';
import iconoCosmeticaActive from '../assets/inicio/iconos/black/frasco-cosm-tico-Blanco1.png';
import iconoVinosActive from '../assets/inicio/iconos/black/botella-de-vino-con-Blanco1.png';
import iconoAnimalActive from '../assets/inicio/iconos/black/silueta-de-mascota---frasco-Blanco1.png';
import iconoManufactureraActive from '../assets/inicio/iconos/black/engrane-Blanco2.png';
import iconoEventosMasivosActive from '../assets/inicio/iconos/black/Estadio-Negro.png';

import iconoLista from '../assets/iconos/etiquetaBullet.png';

/*Contenido de Soluciones Industriales */
const industrias = [
  {
    id: 1,
    nombre: 'Alimentos y Bebidas',
    hrefname: 'alimentos-y-bebidas',
    nombredescripcion:'Alimentos y bebidas',
    icono: iconoAlimentos,
    iconoActive: iconoAlimentosActive,
    descripcion: 'Etiquetas que resisten, cumplen y lucen.',
    txt1descripcion: [
      ['En esta industria no hay espacio para errores: tus etiquetas deben ', <strong>soportar humedad, cambios de temperatura y cumplir con normativas sanitarias.</strong>],
    ],
    txt2descripcion:'En Mega Label, combinamos experiencia, tecnología y control de calidad 100% en línea para que tu producto llegue impecable al consumidor.',
    enlistado:'Te ofrecemos:',
    caracteristicas: [
      [<strong>Etiquetas autoadheribles:</strong>,' ideales para empaques flexibles y rígidos.'], 
      [<strong>Etiquetas termoencogibles (mangas):</strong>, '  cobertura total para botellas y envases cilíndricos.'], 
      [<strong>Etiquetas resistentes a refrigeración y humedad:</strong>, ' legibles en todo momento.'],
      [<strong>Opción de acabados especiales:</strong>, ' metalizados, holográficos, aromas, cold foil.'],
      ['Materiales seguros y certificaciones ', <strong>Disney, NBC UNIVERSAL e ISO 22000:2018, </strong>, ' garantizando la inocuidad alimentaria.'],
    ],
    img: getImageSolInd('Alimentos-y-bebidas-01.webp'),
    img2: getImageSolInd('Alimentos-y-bebidas-02.webp'),
    txtbanner:[
      [<strong>¿Tu producto necesita destacar sin comprometer la seguridad?</strong>, ' Cotiza ahora y encuentra la solución exacta.'],
    ],
    txtbtn:'Cotiza ahora'
  },
  {
    id: 2,
    nombre: 'Industria Farmacéutica Humana y Veterinaria',
    hrefname: 'industria-farmaceutica-humana-y-veterinaria',
    nombredescripcion:'Industria farmacéutica humana y veterinaria',
    icono: iconoFarmaceutica,
    iconoActive: iconoFarmaceuticaActive,
    descripcion: 'Etiquetas con precisión y cumplimiento normativo.',
    txt1descripcion: [
      ['Desde información legible, hasta resistencia en condiciones críticas. Nuestras etiquetas cumplen con normativas específicas que garantizan la calidad, autenticidad y trazabilidad de los productos.'],
    ],
    txt2descripcion:'',
    enlistado:'Soluciones clave:',
    caracteristicas: [
      [<strong>Etiquetas de seguridad </strong>,'(holográficas, scratch-off, VOID) que dificultan la falsificación.'], 
      [<strong>Etiquetas booklet</strong>, ' para información extendida.'], 
      [<strong>Etiquetas resistentes</strong>, ' a químicos y humedad.'],
      [<strong>Personalización</strong>, ' con datos variables para lotes y caducidades.'],
      [<strong>Certificación ISO 22000</strong>, ' y materiales aptos para la industria.'],
    ],
    img: getImageSolInd('Industria-farmaceutica-01.webp'),
    img2: getImageSolInd('Industria-farmaceutica-02.webp'),
    txtbanner:[
      [<strong>¿Necesitas etiquetas seguras y normativas en el mejor tiempo posible?</strong>],
    ],
    txtbtn:'Solicita tu cotización'
  },
  {
    id: 3,
    nombre: 'Cosmética y Belleza',
    hrefname: 'cosmetica-y-belleza',
    nombredescripcion:'Industria cosmética y belleza',
    icono: iconoCosmetica,
    iconoActive: iconoCosmeticaActive,
    descripcion: 'Etiquetas que elevan la estética sin perder funcionalidad.',
    txt1descripcion: [
      ['El diseño vende, pero la resistencia importa mucho. Creamos etiquetas con acabados premium que soportan uso frecuente y ambientes húmedos, mantienen la higiene, sin perder impacto visual.'],
    ],
    txt2descripcion:'',
    enlistado:'Te ofrecemos:',
    caracteristicas: [
      [<strong>Etiquetas metalizadas </strong>,', holográficas y con efectos especiales.'], 
      [<strong>Acabados sensoriales</strong>, ' (soft touch, aroma).'], 
      [<strong>Mangas termoencogibles</strong>, ' para cobertura 360°.'],
      [<strong>Impresión digital</strong>, ' para múltiples variantes.'],
      [<strong>Control de calidad línea por línea</strong>, ' para un resultado impecable.'],
    ],
    img: getImageSolInd('Ind-cosmetica-y-belleza-01.webp'),
    img2: getImageSolInd('Ind-cosmetica-y-belleza-02.webp'),
    txtbanner: [
      ['¿Buscas etiquetas que luzcan premium y duren?'],
    ],
    txtbtn:'Escríbenos'
  },
  {
    id: 4,
    nombre: 'Vinos y Licores',
    nombredescripcion:'Vinos y Licores',
    hrefname: 'vinos-y-licores',
    icono: iconoVinos,
    iconoActive: iconoVinosActive,
    descripcion: 'Etiquetas que destacan en anaquel y resisten hielo y humedad.',
    txt1descripcion: [
      ['Sabemos que el detalle define la percepción de tu marca. Nuestras soluciones combinan elegancia, durabilidad y acabados que atraen miradas en entornos exigentes.'],
    ],
    txt2descripcion:'',
    enlistado: 'Somos más que una etiqueta:',
    caracteristicas: [
      [<strong>Etiquetas autoadheribles </strong>,'resistentes al frío y la humedad.'], 
      [<strong>Acabados sofisticados:</strong>, ' stamping, relieve, cold foil, glow in the dark.'], 
      [<strong>Opción de papeles</strong>, ' texturizados y premium.'],
      [<strong>Impresión digital</strong>, ' para tirajes cortos con variantes.'],
      [<strong>Sustentabilidad integrada</strong>, ' en materiales y procesos.'],
    ],
    img: getImageSolInd('Vinos-y-Licores-01.webp'),
    img2: getImageSolInd('Vinos-y-Licores-02.webp'),
    txtbanner:[
      ['¿Quieres que tu etiqueta comunique calidad desde el primer vistazo?'],
    ],
    txtbtn: 'Solicita tu cotización'
  },
  {
    id: 5,
    nombre: 'Industria Manufacturera',
    nombredescripcion:'Industria Manufacturera',
    hrefname: 'insdustria-manufacturera',
    icono: iconoManufacturera,
    iconoActive: iconoManufactureraActive,
    descripcion: 'Etiquetas funcionales para trazabilidad y procesos industriales.',
    txt1descripcion: [
      ['Diseñadas para durar en entornos exigentes, nuestras etiquetas soportan manipulación constante, fricción y condiciones extremas. Además de siempre aportar la información necesaria y puntual.'],
    ],
    txt2descripcion:'',
    enlistado:'Te ofrecemos:',
    caracteristicas: [
      [<strong>Etiquetas de seguridad </strong>,'y serialización.'], 
      [<strong>Resistencia</strong>, ' a abrasión, calor y humedad.'], 
      [<strong>Datos variables</strong>, ' para control de inventario.'],
      [<strong>Adhesión garantizada</strong>, ' en múltiples sustratos.'],
      [<strong>Formatos especiales</strong>, ' (nylon, PET, etc.).'],
    ],
    img:  getImageSolInd('Ind-Manufacturera-01.webp'),
    img2: getImageSolInd('Ind-Manufacturera-02.webp'),
    txtbanner:['¿Tus procesos requieren etiquetas que aguanten todo?'],
    txtbtn:'Hablemos'
  },
  {
    id: 6,
    nombre: 'Otras Industrias',
    nombredescripcion:'Otras Industrias',
    hrefname: 'otras-industrias',
    icono: iconoAnimal,
    iconoActive: iconoAnimalActive,
    descripcion: 'Etiquetas resistente y seguras para productos de diferentes industrias.',
    txt1descripcion: [
      ['En diferentes sectores la seguridad y claridad son clave, por lo que creamos etiquetas especializadas para cada sector que puedan soportar condiciones adversas manteniendo una durabilidad alta sin perder legibilidad ni adherencia.'],
    ],
    txt2descripcion:'',
    enlistado:'Soluciones clave para industrias:',
    caracteristicas: [
      [<strong>Animal </strong>,''], 
      [<strong>Automotriz</strong>, ''], 
      [<strong>Textil</strong>, ''],
      [<strong>Pinturas</strong>, ' y otras más.'],
    ],
    img: getImageSolInd('Otras-Industrias-01.webp'),
    img2: getImageSolInd('Otras-Industrias-02.webp'),
    txtbanner:[
      ['¿Necesitas etiquetas que garanticen seguridad y cumplimiento?'],
    ],
    txtbtn:'Habla con un experto'
  },
  {
    id: 7,
    nombre: 'Eventos Masivos',
    nombredescripcion:'Eventos Masivos',
    hrefname: 'eventos-masivos',
    icono: iconoEventosMasivos,
    iconoActive: iconoEventosMasivosActive,
    descripcion: 'vasos promocionales inmold.',
    txt1descripcion: [
      ['Gracias a la tecnología Inmold, las etiquetas se integran directamente en el vaso, evitando desgaste y garantizando un acabado profesional. Lo que hace que podamos brindarte diseños personalizados con gran calidad y durabilidad, ideales para destacar tu marca.'],
    ],
    txt2descripcion:'',
    enlistado:'Soluciones clave para industrias:',
    caracteristicas: [
      ['Diseños únicos y licencias ', <strong>Disney y NBC Universal. </strong>], 
      [<strong>Variedad de materiales</strong>, ' como: orange peel, transparente, liso brillante, high gloss, coloreable, metalizado, termocromático.'], 
      [<strong>Certificación ISO 22000</strong>, ' y materiales aptos para la industria.'],
      [<strong>Durabilidad</strong>, ' en diseños diferentes.'],
      ['Vasos para', <strong> bebidas frías y calientes.</strong>],
      [<strong>Opción de usarse</strong>, ' con tapas o sin tapas.'],
    ],
    img: getImageSolInd('Eventos-Masivos-01.webp'),
    img2: getImageSolInd('Eventos-Masivos-02.webp'),
    txtbanner:[
      ['¿Necesitas promocionales que impacten para tu evento?'],
    ],
    txtbtn:'Habla con un experto'
  },
];

const SolucionesIndustria = () => {
  const sectionRefs = useRef([]);
  const btnsContainerRef = useRef(null);

  const [hoveredIdx, setHoveredIdx] = useState(null);
  const [activeIdx, setActiveIdx] = useState(0); //  inicia en 0 (primer botón activo)
  //Fue clickeado?
  const [buttonClicked, setButtonClicked] = useState(false);
  //Hay Scroll
  const [scrolled, setScrolled] = useState(false);
  //¿Que evento ocurrio?
  const [eventsOrder, setEventsOrder] = useState(null);
  // El primer botón está activo
  useEffect(() => {
    // Activar el scrollspy manualmente en React
    const bootstrapScrollSpy = new window.bootstrap.ScrollSpy(document.getElementById('scrollspy-container'), {
      target: '#navbar-example3',
      smoothScroll: true,
    });

    return () => {
      bootstrapScrollSpy.dispose(); // Limpiar el scrollspy cuando el componente se desmonta
    };
  }, []);
  //setActiveIdx(null);
  const buttonActive = (idx) => {
    //setTimeout(() => {
      //setActiveIdx(idx);
      if(activeIdx === idx || hoveredIdx === idx){
        return 'active';
      }else{
        return '';
      }
    //}, 50);
    
  };
  // Scroll por click
  const scrollToSection = (idx) => {
    setActiveIdx(idx);
    if (sectionRefs.current[idx]) {
      sectionRefs.current[idx].scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (btnsContainerRef.current && window.innerWidth >= 768) {
        
        const btn = btnsContainerRef.current.querySelectorAll('button')[idx];
        if (btn) {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }
      
    }
    
  };

  const handleScroll = () => {
    const offsets = sectionRefs.current.map(ref => {
      if (!ref) return Number.POSITIVE_INFINITY;
        const rect = ref.getBoundingClientRect();
      return Math.abs(rect.top - 120); // 120 es el scrollMarginTop  
    });
    const minOffset = Math.min(...offsets);
    const idx = offsets.indexOf(minOffset);
    if (idx !== -1 && idx !== activeIdx) {
      setActiveIdx(idx);
    }
  };
 
  window.addEventListener('scroll', handleScroll, { passive: true });
  //return () => window.removeEventListener('scroll', handleScroll);

  return (
    <div className="main-content">
      <div className="container-fluid p-0">
        <div className="page-container pt-0 pb-0">
          {/* Frase de la página */}
          <div className='container-fluid pdg-section-ch'>
            <div className="row align-items-center mb-5">
              <div className="col-12 text-start p-0">
                <h1 className="display-4  lightblack mb-3 tit-principal" style={{width:'60%'}}>
                    <span style={{ color: 'var(--color-principal)'}}>Tu industria tiene retos.
                    </span> Nosotros la etiqueta que te da más.
                </h1>   
              </div>
            </div>
          </div>
          {/*Contenido de la página */}
          <div className='container-fluid pdg-section-scroll' style={{ background: 'var(--color-text-negro-light)', paddingBottom:'5%'}}>
            <div className="row align-items-start mb-5">
              {/* Botones verticales */}
              <div className="col-12 col-md-3 mb-4 mb-md-0 p-0 d-md-block d-none sticky-industrias">
                <div className='sticky-industrias' style={{position: 'relative'}}>
                  <div id="navbar-example3" className="d-flex flex-column gap-3" >
                    {/**
                     * ref={btnsContainerRef}
                     * aria-label={`Ir a sección ${industria.nombre}`}
                        onClick={() => scrollToSection(idx) }
                        onMouseEnter={() => setHoveredIdx(idx)}   
                        onMouseLeave={() => setHoveredIdx(null)}
                        key={industria.id}
                        href={`#${industria.hrefname}`}
                     */}
                    {industrias.map((industria, idx) => (
                      <a
                        key={industria.id}
                        onClick={() => scrollToSection(idx) }
                        onMouseEnter={() => setHoveredIdx(idx)}   
                        onMouseLeave={() => setHoveredIdx(null)}
                        className={`btn btn-custom btn-wscroll d-flex align-items-center ${buttonActive(idx)}`}
                        aria-label={`Ir a sección ${industria.nombre}`}
                      >
                        <img
                          src={
                            activeIdx === idx || hoveredIdx === idx  
                            ? industria.iconoActive
                            : industria.icono
                          }
                          alt={industria.nombre}
                        />
                        <span className="btn-txtscroll text-start">{industria.nombre}</span>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              {/* Contenido de cada industria */}
              <div className="col-12 col-md-9 p-0">
                <div id="scrollspy-container" className="scrollspy-example-2" tabIndex="0">
                {/*
                    ref={el => sectionRefs.current[idx] = el}
                    key={industria.id}
                */}
                  {industrias.map((industria, idx) => (
                    <div    
                      key={industria.id}
                      ref={el => sectionRefs.current[idx] = el}          
                      id={industria.hrefname}
                      className="pb-4 cont-soluciones"
                      style={{
                        scrollMarginTop: '120px',
                        marginBottom: idx === industrias.length - 1 ? '0' : '23.5%'
                      }}
                    >
                      <div className='d-block d-md-none d-lg-none'>
                        <img
                          className='icono-soluciones-mobile'
                          src={activeIdx === idx ? industria.icono : industria.icono}
                          alt={industria.nombre}
                        />
                      </div>
                      <h2 className="mb-0">{industria.nombredescripcion}</h2>
                      <p className='mb-1 short-desc'>{industria.descripcion}</p>
                      {/*
                        <p style={{ color: '#fff' }}>{industria.txt1descripcion}</p>
                      */}
                      {/*<p style={{ color: '#fff' }}>
                        {industria.txt1descripcion}

                        
                      </p>*/}
                      {industria.txt1descripcion.map((txt1, subIdx) => (
                        <p key={subIdx} className="m-0" style={{ color: '#fff' }}>
                          {txt1}
                        </p>
                      ))}
                      <p style={{ color: '#fff', marginBottom: '3%' }}>{industria.txt2descripcion}</p>
                      <div className='container-fluid cont-list'>
                        <p style={{ color: '#fff', fontWeight: '600' }}> {industria.enlistado}</p>
                        <ul style={{ color: '#fff', listStyle: 'none', paddingLeft: '0' }}>
                          {industria.caracteristicas.map((caracteristica, idx2) => (
                            <li key={idx2} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
                              
                              {/*key={idx2} */}
                                <img
                                src={iconoLista}
                                alt=""
                                aria-hidden="true"
                              />
                              {/*
                                <p className='m-0'>
                                  {Array.isArray(caracteristica) ? caracteristica : ''}
                                </p>
                              */}
                              {/** caracteristica*/}
                              {/*<p className='m-0'>
                                {Array.isArray(caracteristica) ? caracteristica : ''}
                              </p>*/}
                              <p className="m-0">
                                {Array.isArray(caracteristica)
                                  ? caracteristica.map((c, subIdx) => (
                                      <span key={subIdx}>{c}</span>
                                    ))
                                  : caracteristica}
                              </p>

                              
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className='container-fluid'>
                        <div className='row'>
                          <div className='col-md-6 col-12 p-md-0 pe-md-3 p-0'>
                            <img src={industria.img} alt={industria.nombre}/>
                          </div>
                          <div className='col-md-6 col-12 p-md-0 p-0 ps-md-3 pt-md-auto pt-3'> 
                            <img src={industria.img2} alt={industria.nombre}/>
                          </div> 
                        </div>
                      </div>
                      <div className='container-fluid question'>
                        <div className='row align-items-center'>
                          <div className='col-md-8 col-12'>
                            {/*
                            <p className="m-0">
                                {Array.isArray(caracteristica)
                                  ? caracteristica.map((c, subIdx) => (
                                      <span key={subIdx}>{c}</span>
                                    ))
                                  : caracteristica}
                              </p>
                            
                            */}
                            {/*
                            <p className="m-0">
                              {industria.txtbanner}
                            </p>
                            */}
                            {industria.txtbanner.map((txt, subIdx) => (
                              <p key={subIdx} className="m-0">
                                {txt}
                              </p>
                            ))}
                            
                            
                          </div>
                          <div className='col-md-4 col-12 d-flex justify-content-end'>
                            <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom p-3">
                              {industria.txtbtn}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolucionesIndustria; 